import logoYugioh from '../images/logo-yugioh.png';
import { FaBars } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { toggleSidebar } from '../store/sidebar/action';
import { useDispatch } from 'react-redux';

const Navbar = () => {
  const dispatch = useDispatch()

  const changeShow = (e) => {
    e.preventDefault()
    dispatch(toggleSidebar())
  }
  return (
    <>
      <nav
        className="
          z-50
          bg-gray-300
          flex
          w-full
          h-20
          fixed
          p-3"
      >
        <div
          className="
            flex-1
            pl-2"
        >
          <div className=" w-max h-14">
            <Link
            to="/">
              <img className="h-full" src={logoYugioh} alt="yugioh_logo"/>
            </Link>
          </div>
        </div>
        <button
          onClick= { changeShow }
          className="
            flex
            flex-col
            justify-center
            items-center
            lg:hidden
            text-3xl
            cursor-pointer"
        >
          <FaBars />
        </button>
        <button
          className=" 
            hidden           
            lg:inline-block
            text-2xl
            mx-3
            cursor-pointer"
        >
          <Link to="/mydeck">
            My Deck
          </Link>
        </button>
        <button
          className=" 
            hidden           
            lg:inline-block
            text-2xl
            mx-3
            cursor-pointer"
        >
          <Link to="/">
            Home
          </Link>
        </button>
      </nav>
    </>
  )
}

export default Navbar